/* NINEPADEL collection pages: filter dropdowns, AJAX filtering/sorting via the Section Rendering API,
   "Show more" pagination and history. Everything works without JS as a plain GET form and links. */
(function(){
  var root = document.querySelector('[data-npc]');
  if(!root) return;
  document.documentElement.classList.add('npc-js');
  var sid = root.getAttribute('data-section');
  var SWAP = ['[data-npc-ql]', '[data-npc-bar]', '[data-npc-results]'];
  var ctrl = null;

  function abs(url){ return new URL(url, location.href); }
  function sectionUrl(url){ var u = abs(url); u.searchParams.set('section_id', sid); return u.toString(); }
  function cleanUrl(url){ var u = abs(url); u.searchParams.delete('section_id'); u.searchParams.delete('page'); return u.pathname + u.search; }
  function fetchDoc(url){
    if(ctrl) ctrl.abort();
    ctrl = ('AbortController' in window) ? new AbortController() : null;
    return fetch(sectionUrl(url), { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'text/html' } })
      .then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function(t){ return new DOMParser().parseFromString(t, 'text/html'); });
  }
  function results(){ return document.querySelector('[data-npc-results]'); }
  function busy(on){ var r = results(); if(r) r.setAttribute('aria-busy', on ? 'true' : 'false'); }

  /* ---------- dropdowns ---------- */
  function openDetails(){ return root.querySelector('[data-npc-bar] details[open]'); }
  function closeAll(except){
    root.querySelectorAll('[data-npc-bar] details[open]').forEach(function(d){ if(d !== except) d.open = false; });
  }
  function place(d){
    var pop = d.querySelector('.pop'), bar = d.closest('.tb3');
    if(!pop || !bar) return;
    if(window.innerWidth <= 700){ pop.style.left = ''; return; }
    var s = d.querySelector('summary').getBoundingClientRect(), b = bar.getBoundingClientRect();
    pop.style.left = '0px';
    var w = pop.offsetWidth;
    var left = Math.max(12, Math.min(s.left, window.innerWidth - w - 12));
    pop.style.left = (left - b.left) + 'px';
  }
  document.addEventListener('toggle', function(e){
    var d = e.target;
    if(!d.matches || !d.matches('[data-npc-bar] details')) return;
    if(d.open){ closeAll(d); place(d); }
  }, true);
  document.addEventListener('click', function(e){
    var d = openDetails();
    if(d && !d.contains(e.target)) d.open = false;
  });
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var d = openDetails();
    if(d){ d.open = false; d.querySelector('summary').focus(); }
  });
  window.addEventListener('resize', function(){ var d = openDetails(); if(d) place(d); });

  /* ---------- load a filtered/sorted view ---------- */
  function load(url, push){
    var od = openDetails(), openKey = od ? od.getAttribute('data-key') : null;
    var active = document.activeElement, focusId = active && root.contains(active) ? active.id : '';
    var popScroll = od ? od.querySelector('.pop').scrollTop : 0;
    busy(true);
    return fetchDoc(url).then(function(doc){
      SWAP.forEach(function(sel){
        var cur = document.querySelector(sel), next = doc.querySelector(sel);
        if(cur && next) cur.replaceWith(next);
      });
      if(push) history.pushState({ npc: true }, '', cleanUrl(url));
      if(openKey){
        var nd = root.querySelector('[data-npc-bar] details[data-key="' + openKey.replace(/"/g, '\\"') + '"]');
        if(nd){ nd.open = true; place(nd); var p = nd.querySelector('.pop'); if(p) p.scrollTop = popScroll; }
      }
      if(focusId){ var f = document.getElementById(focusId); if(f) f.focus({ preventScroll: true }); }
      /* If the bar is stuck and the grid got shorter, bring the top of the results into view. */
      var r = results(), bar = root.querySelector('[data-npc-bar]');
      if(r && !openKey){
        var offset = (bar ? bar.getBoundingClientRect().bottom : 0) + 8;
        var top = r.getBoundingClientRect().top;
        if(top < offset - 20) window.scrollTo({ top: window.scrollY + top - offset, behavior: 'smooth' });
      }
    }).catch(function(err){
      if(err && err.name === 'AbortError') return;
      window.location.href = cleanUrl(url);
    }).finally(function(){ busy(false); });
  }

  function formUrl(form){
    var p = new URLSearchParams();
    var sortSel = form.querySelector('[data-npc-sort]'), def = sortSel ? sortSel.getAttribute('data-default') : null;
    new FormData(form).forEach(function(v, k){
      if(String(v).trim() === '') return;
      if(k === 'sort_by' && v === def) return;
      p.append(k, v);
    });
    var q = p.toString();
    return form.getAttribute('action').split('?')[0] + (q ? '?' + q : '');
  }

  var priceTimer;
  root.addEventListener('change', function(e){
    var form = e.target.closest('[data-npc-form]');
    if(!form) return;
    if(e.target.type === 'number'){
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function(){ load(formUrl(form), true); }, 150);
      return;
    }
    load(formUrl(form), true);
  });
  root.addEventListener('submit', function(e){
    var form = e.target.closest('[data-npc-form]');
    if(!form) return;
    e.preventDefault();
    clearTimeout(priceTimer);
    var d = openDetails(); if(d) d.open = false;
    load(formUrl(form), true);
  });

  root.addEventListener('click', function(e){
    var more = e.target.closest('[data-npc-more-btn]');
    if(more){ e.preventDefault(); showMore(more); return; }
    var a = e.target.closest('a[data-npc-link]');
    if(!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var u = abs(a.href);
    if(u.origin !== location.origin || u.pathname !== location.pathname) return; /* another collection: normal navigation */
    e.preventDefault();
    var d = openDetails(); if(d) d.open = false;
    load(u.pathname + u.search, true);
  });

  /* ---------- show more ---------- */
  function showMore(btn){
    var grid = root.querySelector('[data-npc-grid]');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Loading…';
    fetchDoc(btn.href).then(function(doc){
      var nextGrid = doc.querySelector('[data-npc-grid]'), nextMore = doc.querySelector('[data-npc-more]');
      var first = null;
      if(nextGrid){
        Array.prototype.slice.call(nextGrid.children).forEach(function(el){
          if(el.hasAttribute('data-npc-promo') || el.classList.contains('empty2')) return;
          grid.appendChild(el);
          if(!first) first = el;
        });
      }
      var cur = root.querySelector('[data-npc-more]');
      if(cur && nextMore) cur.replaceWith(nextMore);
      if(first){ var link = first.matches('a') ? first : first.querySelector('a'); if(link) link.focus({ preventScroll: true }); }
    }).catch(function(err){
      if(err && err.name === 'AbortError') return;
      window.location.href = btn.href;
    });
  }

  var basePath = location.pathname;
  window.addEventListener('popstate', function(){ if(location.pathname === basePath) load(location.href, false); });
})();
